import { Globals } from "../CoreApp/Globals";

export function StartTiming() {
  var d2 = new Date();
  Globals._mcTimer = d2.getTime();
}
